import { render, staticRenderFns } from "./PostDelete.vue?vue&type=template&id=7e16cd6b&scoped=true"
import script from "./PostDelete.vue?vue&type=script&lang=js"
export * from "./PostDelete.vue?vue&type=script&lang=js"
import style0 from "./PostDelete.vue?vue&type=style&index=0&id=7e16cd6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e16cd6b",
  null
  
)

export default component.exports